import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ListRequests from "../../../../../components/@schedulers/request/ListRequests";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function RequestsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListRequests 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       